{
	"type": "line",
	"minzoom": 8,
	"layout": {
		"line-sort-key": [
			"match",
			["get", "average_freeflow_speed_band"],
			"< 5",
			1,
			"5-10",
			2,
			"10-15",
			3,
			"15-20",
			4,
			"20-25",
			5,
			"25-30",
			6,
			"30-35",
			7,
			"35-40",
			8,
			"40-45",
			9,
			"45-50",
			10,
			"50-55",
			11,
			"55-60",
			12,
			"60-65",
			13,
			"65-70",
			14,
			"70-75",
			15,
			"75-80",
			16,
			"80-85",
			17,
			"85-90",
			18,
			"90-95",
			19,
			"95-100",
			20,
			"100-105",
			21,
			"105-110",
			22,
			"110-115",
			23,
			"115-120",
			24,
			0
		]
	},
	"paint": {
		"line-width": 2.5,
		"line-color": [
			"case",
			["==", ["get", "average_freeflow_speed_band"], null],
			"#a2a2a2",
			[
				"match",
				["get", "average_freeflow_speed_band"],
				"< 5",
				"#1a9641",
				"5-10",
				"#46b13b",
				"10-15",
				"#72cc35",
				"15-20",
				"#9ad32e",
				"20-25",
				"#c2da28",
				"25-30",
				"#d5d221",
				"30-35",
				"#e8c91a",
				"35-40",
				"#eeb716",
				"40-45",
				"#f5a512",
				"45-50",
				"#f5900e",
				"50-55",
				"#f57b0b",
				"55-60",
				"#ee6608",
				"60-65",
				"#e85206",
				"65-70",
				"#de4105",
				"70-75",
				"#d33004",
				"75-80",
				"#cc2a04",
				"80-85",
				"#c62303",
				"85-90",
				"#b71902",
				"90-95",
				"#a80f02",
				"95-100",
				"#8c0802",
				"100-105",
				"#6f0101",
				"105-110",
				"#380000",
				"110-115",
				"#000000",
				"#000000"
			]
		]
	}
}
